import React from "react";
import { useGreenScreenBackgrounds } from "../../../Providers/GreenScreenBackgroundsProvider";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0),
  },
  imageList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    maxWidth: "100%",
    "& button": {
      border: "none",
      height: "104px",
      padding: "0",
      overflow: "hidden",
      position: "relative",
      marginLeft: theme.spacing(1),
      borderRadius: "0",
      display: "block",
      backgroundColor: "transparent",
      "& img": {
        height: "100%",
      },
    },
  },
  selectedImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.primary.main + "aa",
  },
}));

export default ({ handleUpdate, resource }) => {
  const [backgrounds, loading] = useGreenScreenBackgrounds();
  const classes = useStyles();

  if (loading) {
    return <>Loading</>;
  }

  console.log("Resource", resource, backgrounds);

  return (
    <div className={classes.container}>
      <ul className={classes.imageList}>
        {backgrounds.map((background) => {
          return (
            <li key={background.uuid}>
              <button onClick={() => handleUpdate(background)}>
                <img
                  src={`/system/gsbackground.php?uuid=${background.uuid}&rotation=0&effect=original`}
                />
                {background.uuid == resource?.image?.background?.uuid && (
                  <div className={classes.selectedImage} />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
